import type { SwotCategory } from '../context/types';
import type { LevelLabel, RiskKind } from './types';

export function computeLevel(probability: number, impact: number): number {
  return probability * impact;
}

export function levelLabel(level: number): LevelLabel {
  if (level <= 4) return 'bajo';
  if (level <= 9) return 'medio';
  if (level <= 16) return 'alto';
  return 'critico';
}

export const LEVEL_LABEL_TEXT: Record<LevelLabel, string> = {
  bajo: 'Bajo',
  medio: 'Medio',
  alto: 'Alto',
  critico: 'Crítico',
};

/** Colores planos por umbral (sin gradientes). */
export const LEVEL_CELL_CLASS: Record<LevelLabel, string> = {
  bajo: 'bg-green-100 border-green-300 text-green-900',
  medio: 'bg-yellow-100 border-yellow-300 text-yellow-900',
  alto: 'bg-orange-100 border-orange-300 text-orange-900',
  critico: 'bg-red-100 border-red-300 text-red-900',
};

export const RISK_KIND_LABEL: Record<RiskKind, string> = {
  riesgo: 'Riesgo',
  oportunidad: 'Oportunidad',
};

export const RISK_STATUS_LABEL: Record<string, string> = {
  identificado: 'Identificado',
  evaluado: 'Evaluado',
  en_tratamiento: 'En tratamiento',
  monitoreado: 'Monitoreado',
  cerrado: 'Cerrado',
};

export const RISK_TREATMENT_LABEL: Record<string, string> = {
  mitigar: 'Mitigar',
  aceptar: 'Aceptar',
  transferir: 'Transferir',
  evitar: 'Evitar',
  explotar: 'Explotar',
};

export const ACTION_STATUS_LABEL: Record<string, string> = {
  pendiente: 'Pendiente',
  en_progreso: 'En progreso',
  completada: 'Completada',
};

export const ASSESSMENT_KIND_LABEL: Record<string, string> = {
  inicial: 'Inicial',
  residual: 'Residual',
};

export const RISK_IMPORT_FORMAT_LABEL: Record<string, string> = {
  fq22: 'FQ-22 (operativo / IPER)',
  fgl05: 'F-GL-05 (estratégico)',
  unknown: 'No reconocido',
};

export const RISK_IMPORT_COUNT_LABEL: Record<string, string> = {
  hierarchyPaths: 'Rutas jerárquicas (NIVELES)',
  studies: 'Estudios',
  activities: 'Actividades',
  risks: 'Riesgos y oportunidades',
  swotEntries: 'Entradas FODA',
  orgUnits: 'Unidades organizativas',
  swot: 'Entradas FODA',
};

export const RISK_IMPORT_SEVERITY_LABEL: Record<string, string> = {
  error: 'Error',
  warning: 'Advertencia',
};

export function riskImportCountLabel(key: string): string {
  return RISK_IMPORT_COUNT_LABEL[key] ?? key;
}

/** Mapea categoría FODA al tipo de registro de riesgo/oportunidad. */
export function swotCategoryToRiskKind(category: SwotCategory): RiskKind {
  if (category === 'oportunidad' || category === 'fortaleza') return 'oportunidad';
  return 'riesgo';
}

export function buildMatrixLookup(cells: { probability: number; impact: number; count: number }[]) {
  const map = new Map<string, number>();
  for (const cell of cells) {
    map.set(`${cell.probability}-${cell.impact}`, cell.count);
  }
  return map;
}
